module.exports = __webpack_public_path__ + "media/assets/images/blog/pexels-cottonbro-agile1-small-47fbfa144e3fa53d006856e48cecba06.jpg";